import React from 'react';
import classnames from 'classnames';

const Row = props => (
  <div className={classnames(props.className)}>{props.children}</div>
);

export default Row;